import {
  AddPlusIcon,
  EditPensilIcon,
  ShareProductIcon,
  TrashV2Icon,
  ViewInfoIcon,
  ImagineLogo,
  MagicToolIcon,
  DashboardDimension,
} from '../assets/icons';
import { Link, useNavigate } from 'react-router-dom';
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { merge, startCase, toLower } from 'lodash';

import { Carousel } from 'react-bootstrap';
import CircularProgress from '../components/CircularProgress/CircularProgress';
import { DropdownMenu } from '../screens/subscriptionComponents/DropdownMenu';
import { DuplicateIcon } from '../components/icons/DuplicateIcon';
import { ElipsisTooltip } from './ElipsisTooltip';
import Image from './Image';
import { MemberThumbnail } from './ThumbnailCardUI';
import ReactTimeAgo from 'react-time-ago';
import { RiImageLine } from 'react-icons/ri';
import cx from 'classnames';
import { getSharingUserDetailsList } from '../helpers/api';
import { getExtensionFromURL, pick3DModelUrl } from '../helpers/jsHelper';
import { icons } from '../assets';
import styles from './thumbnailCardV2.module.scss';
import { useSelector } from 'react-redux';
import useToggle from 'react-use/lib/useToggle';
import { useUserContext } from '../contexts/UserContext';
import { filterSelector, selectSelectedMembersBy } from '../redux/slicers/filters/filterSlicer';
import { MODE, useApiList } from '../hooks/useApiList';
import InfiniteScroll from '../components/InfiniteScroll/InfiniteScroll';
import { USER_PROFILE_PLACEHOLDER } from '../constants/assetConstants';
import { paginatedTeamSelector } from '../redux/slicers/team/paginatedTeamSlicer';
import {
  MODEL_TYPES,
  NON_IMAGE_THUMBNAIL_EXTENSIONS,
  THUMBNAIL_CARD_DATE_FORMAT,
  THUMBNAIL_MAX_HEIGHT_RESOLUTION,
  THUMBNAIL_MAX_WIDTH_RESOLUTION,
} from '../constants/constants';
import { RestoreIcon } from '../components/icons/RestoreIcon';
import moment from 'moment';

const {
  InfoIcon,
  DownloadIcon,
  MoveToTextureIcon,
  CollectionIcon,
  ShareIcon,
  BinIcon,
  HeartIcon,
  HeartLineIcon,
  SharedUsersIcon,
  FavoriteIcon,
  FavoriteRedIconV2,
  EditIcon,
  ShareIconNew,
  SharedFilesIcon,
  VideoPlayIcon,
  ModelIcon,
} = icons;

export const ACTION = {
  RETRY: 'RETRY',
  RAISE_TICKET: 'RAISE_TICKET',
  UNDER_REVIEW: 'UNDER_REVIEW',
  RESTORE: 'RESTORE',
  DOWNLOAD: 'DOWNLOAD',
  EDIT: 'EDIT',
  EDIT_WITH_FAST_PREVIEW: 'EDIT_WITH_FAST_PREVIEW',
  MOVE_TO_TEXTURE: 'MOVE_TO_TEXTURE',
  SHARE: 'SHARE',
  ADD_TO_COLLECTION: 'ADD_TO_COLLECTION',
  DELETE: 'DELETE',
  INFO: 'INFO',
  DUPLICATE: 'DUPLICATE',
  DOWNLOAD_3D_FILES: 'DOWNLOAD_3D_FILES',
  COLLECT_3D_FILES: 'COLLECT_3D_FILES',
  START_ONBOARDING: 'START_ONBOARDING',
  START_OVER_ONBOARDING: 'START_OVER_ONBOARDING',
  CONTINUE: 'CONTINUE',
  TAKE_IT_AGAIN: 'TAKE_IT_AGAIN',
  MODEL_VIEWER_3D: 'MODEL_VIEWER_3D',
  ARCHIVE: 'ARCHIVE',
  REUSE: 'REUSE',
  GENERATE_CONTENT: 'GENERATE_CONTENT',
  EDIT_AI: 'EDIT_AI',
  CAN_ASSIGN_TEXTURE: 'CAN_ASSIGN_TEXTURE',
  PRODUCT_SETUP: 'PRODUCT_SETUP',
  GENERATE_DIMENSION_SHOT: 'GENERATE_DIMENSION_SHOT',
  COPY: 'COPY',
  PASTE: 'PASTE',
  OPEN_IN_CURATOR: 'OPEN_IN_CURATOR',
};

const editIn3DModalTypeId = [
  MODEL_TYPES.PROJECTS,
  MODEL_TYPES.PROJECTRENDER,
  MODEL_TYPES.AUTOMATION,
  MODEL_TYPES.ROOM,
  MODEL_TYPES.TEMPLATES,
];

export default function ThumbnailCardV2({
  data,
  thumbnail = null,
  images,
  name,
  subTitle,
  showMenu = true, // show three dot menu
  className = 'common-card',
  date,
  bottomRightText = null,
  menu = [],
  titleProps = null,
  capitalize = false,
  handleSelect = () => {},
  onClick = () => {},
  customActions = {},
  hideFavourite = false,
  dateLabel,

  onDownload,
  downloadLoading,
  onEdit,
  onEditInfo,
  onEditAI,
  onMoveToTextures,
  onShare,
  onDelete,
  onRestore,
  onSelect,
  onFavouriteChange,
  onAddToCollection,
  onReUse,

  onInfoClick,
  infoLoading,
  infoData,

  rotation = 0,
  imageFit,
  highlight,
  designV3 = false,
  onDuplicate,
  tagList,
  tagListStyle = {},
  tagListItemStyle = {},
  brandTag,
  secondLine,
  createVideoThumbnail = null,
  imageOverlay = null,
  blurCard = null,
  children,
  onGenerateContent,
  onGenerateDimension,
  thumbnailCardInfoClassName = '',
  dropdownMenuProps = {},
  onAssignTexture,
  onEditWithFastPreview,
  onClickProductSetup,
  overlayOnCardHover = null,
  iconSideToTitle = null,
  showCheckboxGuestUser = false,
  activeIndex,
  setActiveIndex,
  ...rest
}) {
  const is3DFile = editIn3DModalTypeId.includes(+rest?.itemModelType);
  const ref = useRef(null);
  const navigate = useNavigate();
  const [userListOpen, toggleUserListOpen] = useToggle(false);
  const [actionsOpen, toggleActionsOpen] = useToggle(false);
  const [thumbnailFailed, setThumbnailFailed] = useState(false);
  const { isGuestUser, isGuestLogin } = useUserContext();

  const closeActionsOnOutsideClick = useCallback(
    (event) => {
      if (!ref.current || !ref.current.contains(event.target)) {
        toggleActionsOpen(false);
        toggleUserListOpen(false);
      }
    },
    [toggleActionsOpen, toggleUserListOpen]
  );

  useEffect(() => {
    if (!actionsOpen && !userListOpen) return;
    document.addEventListener('mousedown', closeActionsOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeActionsOnOutsideClick);
  }, [actionsOpen, userListOpen]);

  // actions
  const defaultActions = {
    [ACTION.EDIT]: {
      label: is3DFile ? 'Edit in 3D' : 'Edit',
      onClick: onEdit,
      icon: is3DFile ? ImagineLogo : EditPensilIcon,
    },
    // [ACTION.EDIT_WITH_FAST_PREVIEW]: {
    //   label: 'Edit with fast preview',
    //   onClick: onEditWithFastPreview,
    //   icon: ImagineLogo ,
    // },
    [ACTION.GENERATE_CONTENT]: {
      label: 'Generate Visuals',
      onClick: onGenerateContent,
      icon: ShareIcon,
    },
    [ACTION.GENERATE_DIMENSION_SHOT]: {
      label: 'Generate Dimension Shot',
      onClick: onGenerateDimension,
      icon: DashboardDimension,
    },
    [ACTION.INFO]: {
      label: 'Edit Info',
      onClick: onEditInfo,
      icon: ViewInfoIcon,
    },
    [ACTION.MOVE_TO_TEXTURE]: {
      label: 'Move to Texture',
      onClick: onMoveToTextures,
      icon: MoveToTextureIcon,
    },
    [ACTION.SHARE]: {
      label: 'Share',
      onClick: onShare,
      icon: ShareProductIcon,
    },
    [ACTION.DUPLICATE]: {
      label: 'Duplicate',
      onClick: onDuplicate,
      icon: DuplicateIcon,
    },
    [ACTION.ADD_TO_COLLECTION]: {
      label: 'Add to Collection',
      onClick: onAddToCollection,
      icon: AddPlusIcon,
    },
    [ACTION.DELETE]: {
      label: onRestore ? 'Restore' : 'Delete',
      onClick: onRestore || onDelete,
      icon: onRestore ? RestoreIcon : TrashV2Icon,
    },
    // [ACTION.EDIT_AI]: {
    //   label: 'Magic Tool',
    //   onClick: onEditAI,
    //   icon: MagicToolIcon,
    // },
    [ACTION.REUSE]: {
      label: 'Re-imagine',
      onClick: onReUse,
      icon: ShareIcon,
    },
    // [ACTION.PRODUCT_SETUP]: {
    //   label: 'Product Setup',
    //   onClick: rest?.modelType === MODEL_TYPES.THREEDMODELS ? onClickProductSetup: null,
    //   icon: EditPensilIcon,
    // },
    // [ACTION.CAN_ASSIGN_TEXTURE]: {
    //   label: 'Assign Texture',
    //   onClick: onAssignTexture,
    //   icon: ShareIcon,
    // },
    [ACTION.DOWNLOAD]: {
      label: 'Download',
      loading: downloadLoading,
      onClick: onDownload,
      icon: DownloadIcon,
    }
  };

  const actions = useMemo(() => {
    // if (!actionsOpen) return {};
    return merge({}, defaultActions, customActions);
  }, [downloadLoading, customActions]);

  const combinedTitleProps = titleProps || {
    to: rest?.to,
    as: rest?.to ? Link : undefined,
    target: rest?.target,
  };

  const TitleComponent = combinedTitleProps?.as || 'h6';
  const titleClickable = Boolean(titleProps?.to || titleProps?.onClick);

  const fallbackThumbnailSrc =
    thumbnail || images?.[0]?.thumbnail || data?.thumbnail || data?.thumb || data?.images?.[0]?.thumbnail || '';
  const fallbackThumbnailExtension = (getExtensionFromURL(fallbackThumbnailSrc) || '').toLowerCase();
  const rawThumbnailSrc = NON_IMAGE_THUMBNAIL_EXTENSIONS.includes(fallbackThumbnailExtension)
    ? ''
    : fallbackThumbnailSrc;
  const model3DUrl = pick3DModelUrl(data);
  const previewMediaUrl = rest?.previewMediaUrl || model3DUrl || fallbackThumbnailSrc || '';
  const previewMediaExtension = (getExtensionFromURL(previewMediaUrl) || '').toLowerCase();
  const isVideoAsset = previewMediaExtension === '.mp4';
  const is3DAsset = previewMediaExtension === '.glb' || previewMediaExtension === '.fbx';
  const isCuratorAsset = Boolean(data?.is_created_from_curator && data?.curator_json_file);
  // With no usable image, the card falls back to the media itself.
  const shouldPreviewMedia = Boolean(
    (createVideoThumbnail || isVideoAsset) && (!rawThumbnailSrc || thumbnailFailed) && previewMediaUrl
  );
  // A thumbnail that fails to load should degrade to that fallback rather than
  // leaving the browser's broken-image icon on the card.
  const showMediaFallback = shouldPreviewMedia || thumbnailFailed;

  useEffect(() => {
    setThumbnailFailed(false);
  }, [rawThumbnailSrc]);
  
  const haveAngles = images?.every((a) => a?.thumbnail !== null);

  const preventPropagation = (e) => {
    e.stopPropagation();
  };

  const Tag =
    rest?.redirect &&
    rest?.redirectTarget &&
    rest?.redirectTarget === '_self' &&
    (rest?.redirectURL || rest?.to)
      ? Link
      : 'div';

  const handleDate = (value) => {
    if (!value) return null;
    const original = moment(value).local().format(THUMBNAIL_CARD_DATE_FORMAT);
    return <span className="ms-1">{original}</span>;
  };

  return (
    <div
      className={`${styles.thumbnailCardV2} ${className} ${
        rest?.selected ? styles?.cardSelected : ''
      }`}
      ref={(r) => {
        ref.current = r;
      }}>
      {children || (
        <>
          <Tag
            {...(rest?.redirectTarget &&
              rest?.redirectTarget === '_self' && {
                to: rest?.redirectURL || rest?.to,
                onClick: () => {
                  if (rest?.isAnySelected) {
                    rest?.resetSelection?.();
                  }
                  if (rest?.isSharedPage || rest?.isCollectionItem || rest?.savePreviousRoute) {
                    window.$previousURL = `${window.location.pathname}${window.location.search}`;
                    window.$restrictFilter = true;
                    window.$scrollPosition = window.scrollY;
                    if (rest?.sharePageColletionCard && rest?.isSharedPage) {
                      window.$restrictFilter = null;
                    }
                  }
                },
              })}
            className={styles.thumbnailCardImage}
            {...(!(rest?.redirect && rest?.redirectTarget === '_self') && {
              onClick: (e) => {
                e.preventDefault();
                if (rest?.isSharedPage || rest?.isCollectionItem || rest?.savePreviousRoute) {
                  window.$previousURL = `${window.location.pathname}${window.location.search}`;
                  window.$restrictFilter = true;
                  window.$scrollPosition = window.scrollY;
                  if (rest?.sharePageColletionCard && rest?.isSharedPage) {
                    window.$restrictFilter = null;
                  }
                }
                if (rest?.redirect && (rest?.redirectURL || rest?.to)) {
                  if (rest?.redirectTarget && rest?.redirectTarget === '_self') {
                    navigate(rest?.redirectURL || rest?.to);
                  } else {
                    window.open(rest?.redirectURL || rest?.to, rest?.redirectTarget || '_blank');
                  }
                  return;
                }
                rest?.onCardClick && rest?.onCardClick();
                if (rest?.openDetails) {
                  rest?.openDetails(data?.id);
                  return;
                }
                onClick?.(data);
              },
            })}>
            {tagList?.length > 0 && (
              <div
                className={`${styles.tagList} ${
                  tagList[0].type === 'deleteRequest' ? styles.bottomPosition : ''
                } ${rest?.isFavourite ? styles.favourited : ''}`}
                style={{ ...tagListStyle, ...(rest?.isFavourite ? { right: '1.75rem' } : {}) }}>
                {tagList.map((tag, idx) => {
                  const tagClassName = cx({
                    [styles.tagDefault]: !tag.type || tag.type === '',
                    [styles.tagSuccess]: tag.type === 'success',
                    [styles.tagError]: tag.type === 'error',
                    [styles.tagPending]: tag.type === 'pending',
                    [styles.tagDisabled]: tag.type === 'disabled',
                    [styles.tagSecondary]: tag.type === 'secondary',
                    [styles.tagDeleteRequest]: tag.type === 'deleteRequest',
                  });

                  return (
                    <div
                      key={idx}
                      className={cx(tagClassName, styles.tag)}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        tag?.onClick?.();
                      }}
                      style={tagListItemStyle}>
                      {tag.label}
                    </div>
                  );
                })}
              </div>
            )}

            {(!showCheckboxGuestUser ? !isGuestUser() && !isGuestLogin : showCheckboxGuestUser) ? (
              <>
                <div
                  className={`${styles.thumbnailActionCheckBox} ${
                    rest?.selected ? styles.iconVisible : ''
                  }`}>
                  {/* // select card code */}
                  <div
                    className="form-check custom-checkbox"
                    onClick={(e) => preventPropagation(e)}>
                    {onSelect && !rest.isTemplateCard && (
                      <>
                        <input
                          style={{ visibility: 'visible' }}
                          className="form-check-input m-0"
                          type="checkbox"
                          checked={rest?.selected}
                          onChange={() => {
                            onSelect(rest?.id, data, rest?.originalData);
                          }}
                        />
                        <label
                          onClick={(e) => {
                            preventPropagation(e);
                            onSelect(rest?.id, data, rest?.originalData);
                          }}></label>
                      </>
                    )}
                  </div>
                </div>

                {/* // favourite code */}
                {!hideFavourite && !isGuestUser() && !isGuestLogin && (
                  <div
                    className={`${styles.thumbnailActionFavorite} ${
                      rest?.isFavourite ? styles.iconVisible : ''
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onFavouriteChange();
                    }}>
                    {!rest?.favouriteLoading &&
                      (rest?.isFavourite ? (
                        <FavoriteRedIconV2 color="#ff0000" />
                      ) : (
                        <FavoriteIcon color="#141414" />
                      ))}
                    {rest?.favouriteLoading && <CircularProgress size={14} thickness={1} />}
                  </div>
                )}
              </>
            ) : null}

            {userListOpen && (
              <div className="main-item-toggel">
                <SharedUsersList id={rest?.originalData?.id || data?.id || rest?.id} />
              </div>
            )}
            <span className={blurCard}>
              {overlayOnCardHover}
              {images?.length > 1 && haveAngles ? (
                <ImagesCarousel activeIndex={activeIndex} setActiveIndex={setActiveIndex} images={images} />
              ) : designV3 ? (
                showMediaFallback ? (
                  <>
                    {imageOverlay}
                    <CardMediaFallback
                      isVideoAsset={isVideoAsset}
                      is3DAsset={is3DAsset}
                      src={previewMediaUrl}
                      className="designV3"
                    />
                  </>
                ) : (
                  <>
                    {imageOverlay}
                    <img
                      src={images?.length ? images[0]?.thumbnail || rawThumbnailSrc : rawThumbnailSrc}
                      alt="image"
                      className="designV3"
                      onError={() => setThumbnailFailed(true)}
                    />
                    {(isVideoAsset || is3DAsset || isCuratorAsset) ? (
                      <MediaPreviewIndicator
                        mediaType={isVideoAsset ? 'video' : is3DAsset ? 'model' : 'curator'}
                      />
                    ) : null}
                  </>
                )
              ) : showMediaFallback ? (
                <>
                  {imageOverlay}
                  <CardMediaFallback
                    isVideoAsset={isVideoAsset}
                    is3DAsset={is3DAsset}
                    src={previewMediaUrl}
                  />
                </>
              ) : (
                <>
                  {imageOverlay}
                  <Image
                    src={images?.length ? images[0]?.thumbnail || rawThumbnailSrc : rawThumbnailSrc}
                    placeholderWhileLoading
                    hideWithNoSrc
                    ratio={1.4}
                    Icon={rest?.imageIcon}
                    showImageLoading={rest?.showThumbnailLoading}
                    placeholderColor={rest?.placeholderColor || 'var(--image-placeholder)'}
                    style={
                      Number(rotation)
                        ? {
                            objectFit: imageFit || 'cover',
                            transform: `rotate(${Number(rotation)}deg)`,
                          }
                        : { objectFit: imageFit || 'cover' }
                    }
                    // {...imageProps}
                  />
                  {(isVideoAsset || is3DAsset || isCuratorAsset) ? (
                    <MediaPreviewIndicator
                      mediaType={isVideoAsset ? 'video' : is3DAsset ? 'model' : 'curator'}
                    />
                  ) : null}
                </>
              )}
              {rest?.imageText && (
                <div className="itemCount" style={{ pointerEvents: 'none' }}>
                  {rest?.imageText}
                </div>
              )}
            </span>
          </Tag>
          <div
            className={cx(styles.thumbnailCardInfo, thumbnailCardInfoClassName, {
              [styles.selected]: !rest?.selected && highlight === 'info',
              [styles.success]: !rest?.selected && highlight === 'success',
              [styles.error]: !rest?.selected && highlight === 'error',
              [styles.progress]: !rest?.selected && highlight === 'progress',
            })}>
            <div className="overflow-hidden">
              {iconSideToTitle ? (
                <div className={styles.titleWithIcon}>
                  <ElipsisTooltip title={name}>
                    {({ ref, onMouseEnter, onMouseLeave }) => (
                      <TitleComponent
                        {...combinedTitleProps}
                        as={undefined}
                        ref={ref}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        className={cx('thumbnail-title', titleClickable && styles.clickable)}>
                        {TitleComponent === 'h6' ? (
                          <>{capitalize ? startCase(toLower(name)) : name}</>
                        ) : (
                          <h6>{capitalize ? startCase(toLower(name)) : name}</h6>
                        )}
                      </TitleComponent>
                    )}
                  </ElipsisTooltip>
                  {iconSideToTitle}
                </div>
              ) : (
                <ElipsisTooltip title={name}>
                  {({ ref, onMouseEnter, onMouseLeave }) => (
                    <TitleComponent
                      {...combinedTitleProps}
                      as={undefined}
                      ref={ref}
                      onMouseEnter={onMouseEnter}
                      onMouseLeave={onMouseLeave}
                      className={cx('thumbnail-title', titleClickable && styles.clickable)}>
                      {TitleComponent === 'h6' ? (
                        <>{capitalize ? startCase(toLower(name)) : name}</>
                      ) : (
                        <h6>{capitalize ? startCase(toLower(name)) : name}</h6>
                      )}
                    </TitleComponent>
                  )}
                </ElipsisTooltip>
              )}

              {subTitle && (
                <>
                  <div className={styles.subTitle}>
                    <span className={styles.avatar}>UN</span>
                    <span>Username</span>
                  </div>
                </>
              )}
              {date && rest?.userCard ? (
                <div className={styles.subTitle}>
                  {!rest?.isSharedItem ? (
                    <MemberThumbnail
                      user={
                        data?.member_details ||
                        data?.owner_detail?.user ||
                        rest?.originalData?.created_by_details?.user ||
                        rest?.originalData?.created_by_details
                      }
                    />
                  ) : rest?.isSharedItem ? (
                    <SharedUsersIcon
                      onClick={() => {
                        toggleActionsOpen(!actionsOpen ? false : true);
                        toggleUserListOpen(!userListOpen ? true : false);
                      }}
                    />
                  ) : (
                    <>
                      <span className={styles.avatar}>{`${
                        data?.member_details?.first_name?.charAt(0) || name?.charAt(0)
                      }${data?.member_details?.last_name?.charAt(0) || name?.charAt(0)}`}</span>
                    </>
                  )}
                  {(rest?.isSharedItem || date) && !dateLabel ? (
                    handleDate(
                      rest?.isSharedItem
                        ? rest?.originalData?.latest_updated_at || data?.latest_updated_at || date
                        : date
                    )
                  ) : dateLabel ? (
                    <span className="ms-1">{dateLabel}</span>
                  ) : null}
                  {bottomRightText && <span className="ms-2">{bottomRightText}</span>}
                  {brandTag && <span className="ms-2">{brandTag}</span>}
                </div>
              ) : null}
              {brandTag && (
                <div className={`${styles.subTitle} d-flex`}>{<span>{brandTag}</span>}</div>
              )}
              {secondLine && (
                <div className={`${styles.subTitle} d-flex`}>{<span>{secondLine}</span>}</div>
              )}
            </div>
            {showMenu && !isGuestLogin && (
              <DropdownMenu
                {...(rest?.copyLinkBtn && { button: rest?.copyLinkBtn })}
                menu={Object.values(actions).filter((a) => a?.onClick)}
                items={{ id: data.id, data, originalData: rest?.originalData }}
                dropdownMenuProps={dropdownMenuProps}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

const MediaPreviewIndicator = ({ mediaType = '' }) => {
  if (mediaType === 'curator') {
    return (
      <div className={styles.mediaPreviewIndicator}>
        <span
          className={cx(styles.mediaPreviewIndicatorIcon, styles.mediaPreviewIndicatorIconCurator)}>
          <ImagineLogo />
        </span>
      </div>
    );
  }
  const Icon = mediaType === 'video' ? VideoPlayIcon : ModelIcon;

  return (
    <div className={styles.mediaPreviewIndicator}>
      <span className={styles.mediaPreviewIndicatorIcon}>
        <Icon />
      </span>
    </div>
  );
};

// A card with no image of its own falls back to the video, then swaps in a still
// captured from the very frame already on screen, so the card ends up carrying a real
// image rather than a video element. Capturing from the rendered video costs no extra
// download. A cross-origin frame taints the canvas, in which case we keep the video.
const VideoPreview = ({ src, className }) => {
  const videoRef = useRef(null);
  const [poster, setPoster] = useState(null);
  const [requestWithCors, setRequestWithCors] = useState(true);

  const captureFrame = () => {
    const video = videoRef.current;
    if (!video?.videoWidth) return;
    try {
      // The still only ever fills a card-sized tile, so cap it rather than carrying a
      // full-resolution frame around as a data URL. Never scale up: a video already
      // smaller than the cap is captured as-is.
      const scale = Math.min(
        1,
        THUMBNAIL_MAX_WIDTH_RESOLUTION / video.videoWidth,
        THUMBNAIL_MAX_HEIGHT_RESOLUTION / video.videoHeight
      );
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(video.videoWidth * scale);
      canvas.height = Math.round(video.videoHeight * scale);
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      setPoster(canvas.toDataURL('image/jpeg', 0.75));
    } catch (error) {
      // Tainted canvas: leave the video in place rather than blanking the card.
    }
  };

  if (poster) return <img src={poster} alt="" className={className} />;

  return (
    <video
      ref={videoRef}
      // Remounts so the browser refetches when we drop the CORS request.
      key={requestWithCors ? 'cors' : 'plain'}
      src={`${src}#t=0.5`}
      className={className}
      preload="metadata"
      muted
      playsInline
      disablePictureInPicture
      tabIndex={-1}
      {...(requestWithCors ? { crossOrigin: 'anonymous' } : {})}
      onLoadedData={captureFrame}
      onSeeked={captureFrame}
      onError={() => setRequestWithCors(false)}
    />
  );
};

const CardMediaFallback = ({ isVideoAsset, is3DAsset, src, className }) =>
  isVideoAsset && src ? (
    <VideoPreview src={src} className={className} />
  ) : (
    <ImagePlaceholder mediaType={is3DAsset ? 'model' : ''} />
  );

const ImagePlaceholder = ({ mediaType = '' }) => (
  <div className="w-100 h-100 d-flex justify-content-center align-items-center">
    {mediaType === 'video' ? (
      <div className={styles.mediaPlaceholderIcon}>
        <VideoPlayIcon />
      </div>
    ) : mediaType === 'model' ? (
      <div className={styles.mediaPlaceholderIcon}>
        <ModelIcon />
      </div>
    ) : (
      <RiImageLine fontSize={24} className={'placeholderIcon'} />
    )}
  </div>
);

const ImagesCarousel = memo(({ images, hovered, activeIndex, setActiveIndex }) => {
  // Render <button> controls instead of react-bootstrap's default <a>-based
  // ones so the carousel can live inside a parent <Link> (also <a>) without
  // triggering the "<a> cannot appear as a descendant of <a>" warning.
  // Bootstrap's existing CSS classes are reused to keep the visuals identical.
  const handleNav = (delta) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const next = (activeIndex + delta + images.length) % images.length;
    setActiveIndex(next);
  };

  return (
    // Outer wrapper carries .cardCarouselContainer too so the custom <button>
    // arrow controls — which sit as siblings of the inner Carousel — are
    // descendants of .cardCarouselContainer and pick up all the existing
    // arrow styles + the .thumbnail-card:hover { .cardCarouselContainer button { opacity: 1 } }
    // rule. The inner Carousel keeps .cardCarouselContainer designV2_Carousel
    // so its layout (carousel-inner aspect ratio, item positioning) is
    // unchanged from the original.
    <div className="cardCarouselContainer">
      <Carousel
        activeIndex={activeIndex}
        onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
        className="cardCarouselContainer designV2_Carousel"
        indicators={false}
        interval={null}
        controls={false}>
        {images.map((s, i) => (
          <Carousel.Item key={i}>
            {s?.thumbnail ? (
              <Image
                src={s?.thumbnail}
                placeholderWhileLoading
                hideWithNoSrc
                ratio={1.4}
                // {...imageProps}
              />
            ) : (
              <ImagePlaceholder />
            )}
          </Carousel.Item>
        ))}
      </Carousel>
      {images.length > 1 && (
        <>
          <button
            type="button"
            className="carousel-control-prev"
            onClick={handleNav(-1)}
            aria-label="Previous">
            <span className="carousel-control-prev-icon" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="carousel-control-next"
            onClick={handleNav(1)}
            aria-label="Next">
            <span className="carousel-control-next-icon" aria-hidden="true" />
          </button>
        </>
      )}
    </div>
  );
});

const SharedUsersList = memo(({ id }) => {
  const {
    currentUser: { organization },
  } = useUserContext();
  let {
    getSharedFilesQueryFilters: { shared_to, shared_to_org, shared_by },
  } = useSelector(filterSelector);
  let selectedMemberList = useSelector(selectSelectedMembersBy);
  let memberList = useSelector(paginatedTeamSelector);
  if (!shared_to && !shared_to_org && !shared_by && selectedMemberList?.length) {
    shared_by = selectedMemberList?.map((list) => list?.id).join(',');
  }
  if (
    !shared_to &&
    !shared_to_org &&
    !shared_by &&
    !selectedMemberList?.length &&
    memberList?.list?.length
  ) {
    shared_by = memberList?.list?.map((list) => list?.id).join(',');
  }

  const sharedUsersList = useApiList({
    api: getSharingUserDetailsList,
    mode: MODE.PARAMS,
    defaultPerPage: 5,
    params: {
      shared_model_id: id,
      shared_to: shared_to,
      shared_to_org: shared_to_org,
      shared_by: shared_by,
    },
  });

  const [loading, setLoading] = useState(sharedUsersList.loading || true);
  const dataList = sharedUsersList.list.map((a) => {
    if (shared_to) {
      return {
        id: a?.id,
        name: a?.shared_by_detail?.user?.name,
        thumbnail: a?.shared_by_detail?.user?.profile_image,
        organization_id: a?.shared_by_detail?.organization,
        organization_name: a?.shared_by_detail?.organization_detail?.name,
        date: a?.created_at,
      };
    }
    if (shared_to_org) {
      return {
        id: a?.id,
        name: a?.shared_by_detail?.user?.name,
        thumbnail: a?.shared_by_detail?.user?.profile_image,
        organization_id: a?.shared_by_detail?.organization,
        organization_name: a?.shared_by_detail?.organization_detail?.name,
        date: a?.created_at,
      };
    }
    if (shared_by) {
      return {
        id: a?.id,
        name: a?.shared_to_detail?.user?.name,
        thumbnail: a?.shared_to_detail?.user?.profile_image,
        organization_id: a?.shared_to_detail?.organization,
        organization_name: a?.shared_to_detail?.organization_detail?.name,
        date: a?.created_at,
      };
    }

    return {
      id: a?.id,
      name: a?.shared_by_detail?.user?.name,
      thumbnail: a?.shared_by_detail?.user?.profile_image,
      organization_id: a?.shared_by_detail?.organization,
      organization_name: a?.shared_by_detail?.organization_detail?.name,
      date: a?.created_at,
    };
  });

  useEffect(() => {
    setLoading(sharedUsersList.loading);
  }, [sharedUsersList]);

  if (loading) {
    return (
      <div style={{ height: '40px' }} className="d-flex align-items-center justify-content-center">
        <CircularProgress size={14} thickness={1} />
      </div>
    );
  }

  if (!dataList.length) return null;

  return (
    <InfiniteScroll
      dataLength={sharedUsersList.total}
      next={sharedUsersList.fetchNextPage}
      hasMore={sharedUsersList.hasMore}
      loading={sharedUsersList.loading}
      // hasChildren={hasData}
      scrollableTarget="infiniteScroll">
      {dataList.map(({ id, name, thumbnail, organization_id, organization_name, date }) => (
        <div className="inner-item-part bg-white px-2" key={id}>
          <div className="item-image-text">
            <img src={thumbnail || USER_PROFILE_PLACEHOLDER} loading="lazy" />
            <div className="user-info">
              <h5 className="mb-0">
                <span className="name">{name}</span>
                {date && Date.parse(date) ? (
                  <span className="time">
                    <ReactTimeAgo date={Date.parse(date)} />
                  </span>
                ) : null}
              </h5>
              {organization !== organization_id && (
                <h6>
                  <span>{organization_name}</span>
                </h6>
              )}
            </div>
          </div>
        </div>
      ))}
    </InfiniteScroll>
  );
});
